// extracted by mini-css-extract-plugin
export default {"EmbedPreviewIframe":"kLIB9","EmbedPreviewIframe__iframe":"Ip2pW","EmbedPreviewIframe__iframe--hidden":"MoKHq"};